import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify/lib";

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore: Module Error
import colors from "../scss/_colors.scss";

Vue.use(Vuetify);

export default (i18n: VueI18n) =>
  new Vuetify({
    lang: {
      t: (key, ...params) => i18n.t(key, params).toString(),
    },
    breakpoint: {
      thresholds: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
      },
    },
    theme: {
      options: {
        customProperties: true,
      },
      themes: {
        light: {
          primary: colors.primary,
          neutral: colors.neutral,
          secondary: colors.secondary,
          accent: colors.accent,
          error: colors.error,
          info: colors.info,
          success: colors.success,
          warning: colors.warning,
          anchor: colors.anchor,
        },
        dark: {
          primary: colors.primary,
          neutral: colors.neutral,
          secondary: colors.secondary,
          accent: colors.accent,
          error: colors.error,
          info: colors.info,
          success: colors.success,
          warning: colors.warning,
          anchor: colors.anchor,
        },
      },
    },
    icons: {
      iconfont: "fa",
    },
  });
